import React from "react";
import { useTranslation } from "react-i18next";
import {
  Page,
  Card,
  TextContainer,
  SkeletonBodyText,
  SkeletonDisplayText,
  Link,
  FooterHelp,
} from "@shopify/polaris";
import { TitleBar } from "@shopify/app-bridge-react";

export default function LocationsImportNewSkeleton(props) {
  const { t } = useTranslation();
  
  return (
    <Page>
      <TitleBar
        title={t("import.title")}
        breadcrumbs={[{ content: t("import.breadcrumbs.locations"), url: "/places/locations" }]}
      />
      <Card
        sectioned
        primaryFooterAction={{
          content: t("import.new.uploadAndContinue"),
          loading: true,
        }}
      >
        <TextContainer>
          <SkeletonDisplayText />
          <SkeletonBodyText lines={4} />
          <SkeletonBodyText lines={2} />
        </TextContainer>
      </Card>
      <FooterHelp>
        <Link
          onClick={() => {
            window.Beacon("article", "62e12cc1c35bbc3e190ade4e", {
              type: "modal",
            });
          }}
        >
          {t("import.new.needHelp")}
        </Link>
      </FooterHelp>
    </Page>
  );
}
